import React from 'react';
import { intl } from '../../lang/INTL';
import useWidgetStore from '../../store/useWidgetStore';
import { selectColorTheme, selectSelectedHotel } from '../../store/selectors';
import { MobileBtn } from './WidgetMobile.styled';

export const WidgetMobile = () => {
  const theme = useWidgetStore((state) => state.theme);
  const colorTheme = useWidgetStore(selectColorTheme);
  const selectedHotel = useWidgetStore(selectSelectedHotel);

  return (
    <MobileBtn
      className="widget-mobile mobile-only"
      colorTheme={colorTheme}
      $theme={theme}
      variant="primary"
      $flex="none"
      onClick={() => window.bookNow?.()}
    >
      <div className="submit__btn-text">
        {intl.formatMessage({
          id: 'submit.checkAvailability',
          defaultMessage: 'Check Availability',
        })}
      </div>
    </MobileBtn>
  );
};
